import React from 'react';
import { CloseOutlined, BellOutlined, ArrowRightOutlined } from '@ant-design/icons';
import css from './ReplyCaptureDrawerHint.module.scss';

interface ReplyCaptureDrawerHintProps {
  contactFirstName: string;
  onSetUp: () => void;
  onDismiss: () => void;
}

const ReplyCaptureDrawerHint: React.FC<ReplyCaptureDrawerHintProps> = ({
  contactFirstName,
  onSetUp,
  onDismiss,
}) => (
  <div className={css.hint} role="status">
    <BellOutlined className={css.icon} aria-hidden="true" />
    <div className={css.body}>
      <p className={css.text}>
        When {contactFirstName} replies, the message will land in your Gmail.
      </p>
      <button className={css.cta} onClick={onSetUp}>
        Track replies automatically <ArrowRightOutlined className={css.ctaArrow} />
      </button>
    </div>
    <button className={css.dismiss} onClick={onDismiss} aria-label="Dismiss">
      <CloseOutlined />
    </button>
  </div>
);

export default ReplyCaptureDrawerHint;
